CustomEmailValidatorDirective = ->
  require: 'ngModel'
  link: (scope, elem, attrs, ctrl) ->
    MY_EMAIL_REGEXP = /^([\w\.%\+\-]+)@([\w\-]+\.)+([\w]{2,})$/i

    ctrl.$validators.email = (value) ->
      ctrl.$isEmpty(value) || MY_EMAIL_REGEXP.test(value)

module.exports = CustomEmailValidatorDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/custom-email-validator-directive.coffee